<template>
  <div class="container">
    <h2>결제 성공</h2>
    <div v-if="loading">⏳ 결제 결과 불러오는 중...</div>
    <div v-else-if="error">{{ error }}</div>
    <div v-else-if="payResult" class="result-card">
      <div class="result-row">
        <span class="label">상점명</span>
        <span class="value">{{ payResult.CoNm }}</span>
      </div>
      <div class="result-row">
        <span class="label">카드사</span>
        <span class="value">{{ payResult.AppCardName }}</span>
      </div>
      <div class="result-row">
        <span class="label">카드번호</span>
        <span class="value">{{ payResult.CardNum }}</span>
      </div>
      <div class="result-row">
        <span class="label">결제금액</span>
        <span class="value">{{ Number(payResult.Amt).toLocaleString() }}원</span>
      </div>
      <div class="result-row">
        <span class="label">승인일시</span>
        <span class="value">{{ formatDate(payResult.AuthDate) }}</span>
      </div>
      <div class="result-row">
        <span class="label">승인번호</span>
        <span class="value">{{ payResult.AuthCode }}</span>
      </div>
      <div class="result-row">
        <span class="label">상품명</span>
        <span class="value">{{ payResult.GoodsName }}</span>
      </div>
      <div class="result-row">
        <span class="label">구매자 연락처</span>
        <span class="value">{{ payResult.BuyerTel }}</span>
      </div>
      <div class="result-row">
        <span class="label">결제결과</span>
        <span class="value success">{{ payResult.ResultMsg }}</span>
      </div>
      <div class="result-row">
        <span class="label">TID</span>
        <span class="value">{{ payResult.Tid }}</span>
      </div>
    </div>
    <div v-else>데이터가 없습니다.</div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SmartroPaySuccess",
  data() {
    return {
      payResult: null,
      loading: true,
      error: null,
    };
  },
  mounted() {
    const tid = this.$route.query.tid;
    if (!tid) {
      this.error = "tid 파라미터가 없습니다.";
      this.loading = false;
      return;
    }
    axios.get(process.env.VUE_APP_API_BASE + "/api/getPayResultByTid?tid=" + encodeURIComponent(tid))
      .then(res => {
        this.payResult = res.data;
      })
      .catch(() => {
        this.error = "결제 결과를 불러올 수 없습니다.";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    formatDate(str) {
      // 예시: "250916143849" → "2025-09-16 14:38:49"
      if (!str || str.length !== 12) return str;
      const year = "20" + str.slice(0, 2);
      const month = str.slice(2, 4);
      const day = str.slice(4, 6);
      const hour = str.slice(6, 8);
      const min = str.slice(8, 10);
      const sec = str.slice(10, 12);
      return `${year}-${month}-${day} ${hour}:${min}:${sec}`;
    }
  }
};
</script>

<style>
.container {
  max-width: 480px;
  margin: 50px auto;
  padding: 24px 20px 20px 20px;
  border: 1px solid #e0e6ef;
  border-radius: 16px;
  background: #fafdff;
  box-shadow: 0 4px 24px 0 rgba(40,100,220,0.08);
  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;
}
.result-card {
  margin-top: 24px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(40,100,220,0.06);
  padding: 18px 16px;
}
.result-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 0;
  border-bottom: 1px solid #f1f3f7;
  font-size: 1.08rem;
}
.result-row:last-child {
  border-bottom: none;
}
.label {
  color: #4a5a6a;
  font-weight: 500;
}
.value {
  color: #1a2233;
  font-weight: 600;
  letter-spacing: 0.01em;
}
.success {
  color: #1976d2;
}
h2 {
  text-align: center;
  margin-bottom: 18px;
  color: #1976d2;
  font-weight: 700;
}
</style>
